// @flow
import styled from '@emotion/styled';
import { color, FONT_WEIGHTS, typography } from '@tablekit/theme';

export const RichTextWrapper = styled.div`
  .small {
    ${typography('L2')};
  }

  // fix for IE11 inside flex blocks
  &,
  & > * {
    max-width: 100%;
  }
`;

export const ConversationSpeaker = styled.strong`
  color: ${color('primary')};
`;

export const Heading = styled.h1``;

export const markStyles = {
  bold: `font-weight: ${FONT_WEIGHTS.BOLD}`,
  strong: `font-weight: ${FONT_WEIGHTS.BOLD}`,
  underline: 'text-decoration: underline;',
  italic: 'font-style: italic;'
};
